module.exports = __webpack_public_path__ + "static/media/samen_close_up.3f0351d6.jpg";